import { Component, OnInit, Input, Output, ViewChild, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { User1031ListOutputModel } from '../../../shared/models/User1031ListOutputModel';
import { LoaderService } from '../../../shared/providers/loader.service';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { environment } from '../../../../environments/environment';
import { OfferService } from '../../../shared/providers/offer.service';
import { OfferInputModel } from '../../../shared/models/OfferInputModel';
import { ValidationService } from '../../../shared/providers/validation.service';

interface Iexchange {
    userId: number,
    exId: number,
    email: string,
    company: string,
    phone: string
    firstName: string,
    lastName: string
}

@Component({
    selector: 'app-offer-exchange-selector',
    templateUrl: './offer-exchange-selector.component.html'
})
export class OfferExchangeSelectorComponent implements OnInit {

    constructor(private _offerService: OfferService, private Validation: ValidationService, private _toastService: ToastService, private Loader: LoaderService, private http: HttpClient, private modalService: BsModalService, private authService: AuthenticationService) { }
    protected readonly BASE_URL: string = environment.base_url;
    @Input() modalRef: BsModalRef;
    @Input() PropertyId: number;
    @Output() close = new EventEmitter();
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    @Output() selectedExchange = new EventEmitter();
    user: any;
    searchValue: string;
    isAdmin: boolean;
    IsPrincipal = false;
    isBroker = false;
    dtOptions = {};
    table: DataTableDirective;
    users: User1031ListOutputModel[];
    loggedinUserId = 0
    viewMessageIcon: boolean = false;
    principalId = 0;
    rowCount = 0;
    newCount: number;
    assignedCount: number;
    rejectedCount: number;
    brokerId = 0;
    offerInputModel = {} as OfferInputModel;
    usersCount: number = 0;
    statusId: number = 0;
    exchange = {} as Iexchange;
    ngOnInit() {
        
        this.user = this.authService.user;
        var loggedinUserId = this.user.Id;
        const that = this;
        this.isAdmin = false;
        this.isBroker = false;
        let defaultSort = 5;
        let TableColums =
            [{ data: 'ID' },

            ];

        if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
            this.isBroker = true;
            this.viewMessageIcon = true;
            this.loggedinUserId = this.user.Id;
            this.brokerId = this.loggedinUserId;
        }

        const filter =
            {
                BrokerId: this.brokerId,
                PrincipalId: this.principalId,
                IsCallFromBroker: true
            }
        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            processing: true,
            info: false,
            language: {
                zeroRecords: null,
            },
            "pageLength": 10,
            //"order": [[defaultSort, "desc"]],
            bLengthChange: false,
            initComplete: () => $('.dataTables_filter').css('display', 'none'),
            ajax: (dataTablesParameters: any, callback: Function) => {
                dataTablesParameters.Extra_param = filter;
                dataTablesParameters.Extra_param.StatusId = this.statusId;

                const httpHeader = this.Validation.GetAuthHeader();
                that.http
                    .post<DataTablesResponse>(
                        this.BASE_URL + '/opportunity/user1031list/' + loggedinUserId,
                        dataTablesParameters, httpHeader
                    ).subscribe(resp => {
                        $(".dataTables_wrapper table thead").hide();
                        that.users = resp.data ? resp.data : [];
                        this.usersCount = that.users.length;
                        this.rowCount = resp.recordsTotal;
                        if (that.users.length > 0) {
                            this.newCount = this.users[0].CtNewCount;
                            this.assignedCount = this.users[0].CtAssignedCount;
                            this.rejectedCount = this.users[0].CtRejectedCount;
                        }

                        if (resp) {
                            callback({
                                recordsTotal: resp.recordsTotal,
                                recordsFiltered: resp.recordsFiltered,
                                data: []
                            });
                            if (resp.data.length === 0) {
                                $(".dataTables_paginate.paging_full_numbers").hide();
                            }
                            else {
                                $(".dataTables_paginate.paging_full_numbers").show();
                            }
                            $(".paginate_button.first,.paginate_button.last").hide();
                        } else {
                            callback({
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: []
                            });
                            $(".dataTables_paginate.paging_full_numbers").hide();
                        }
                    });
            },
            columns: TableColums
        };

    }
    searchExchange(text: string) {
        this.dtElement.dtInstance.then(x => x.search(text).draw());
    }

    onExchangeSelect(user: any) {
        
        this.offerInputModel.PropertyId = this.PropertyId;
        this.offerInputModel.UserId = user.UserId;
        this._offerService.checkDuplicatePlaceOfferByCoBroker(this.offerInputModel).subscribe(response => {
            if (response == false) {
                this.exchange.userId = user.UserId;
                this.exchange.exId = user.ID;
                this.exchange.email = user.Email;
                this.exchange.phone = user.Phone;
                this.exchange.company = user.Company;
                this.exchange.firstName = user.FirstName;
                this.exchange.lastName = user.LastName;
                this.modalRef.hide();
                this.selectedExchange.emit(this.exchange);
            }
            else {
                this._toastService.addToast({ title: 'Error Occurred', msg: 'Sorry! You cannot submit an offer against this property because, either you or a user associated with ,or you have already submitted an offer and is still under sellers consideration.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
            }
        });


    }

}
